import ReactPopup from 'reactjs-popup';
import { useTranslation } from 'react-i18next';

import { useTrapDeleteModalStore } from '../../../DeleteTrapModal/TrapsDeleteModal';

import comment_icon from 'assets/images/svg/commet_icon.svg';
import { useQRCodeModalStore } from 'components/QRCodeModal/QRCodeModal';
import './ActionCell.scss';
import { useAppSelector } from 'slices';
import { useEditTrapModalStore } from 'pages/Traps/Modals/EditTrapModalStore/EditTrapModalStore';
import { useViewModalStore } from 'components/ViewModal/ViewModal';
import { useCompleteVulModalStore } from 'pages/InteractiveMap/components/Modals/CompleteVulModal/CompleteVulModalStore';
import { Vulnerability } from 'api/vulnerabilities/type';

interface ActionCellProps {
  qrCodeOptions?: {
    msg?: string;
    qr_code: string;
  };
  trap?: { pk: number; serialNumber: string };
  slug?: string;
  comment?: boolean;
  eyes?: boolean;
  isVul?: boolean;
  vulnerability?: Vulnerability;
}
enum StatusTypes {
  Danger = 'danger',
  Warning = 'warning',
  Success = 'success',
  Circle = 'circle',
}
const ActionCell: React.FC<ActionCellProps> = ({ qrCodeOptions, trap, slug, comment, eyes, isVul, vulnerability }) => {
  const { onQRCodeModalOpen } = useQRCodeModalStore();
  const { t } = useTranslation();
  const { openDeleteTrapModal } = useTrapDeleteModalStore();
  const { onCompleteVulOpen } = useCompleteVulModalStore();
  const { onViewCodeModalOpen } = useViewModalStore();
  const { onEditTrapModalOpen } = useEditTrapModalStore();
  const { currentTrapTable } = useAppSelector(state => state.Traps);
  const canDeleteVul =
    vulnerability?.status.name !== StatusTypes.Success && vulnerability?.status.name !== StatusTypes.Circle;
  return (
    <>
      <div className="btn-group d-flex align-items-center justify-content-center" role="group">
        {trap?.serialNumber && slug && (
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => onEditTrapModalOpen(slug, trap, currentTrapTable)}
          >
            <i className="ri-pencil-fill icon icon__edit" />
          </button>
        )}
        {comment && vulnerability && (
          <div className="d-flex justify-content-center">
            <ReactPopup
              trigger={
                <button
                  title={t('MCTDetail.TrapHistoryCard.modal.viewComment')}
                  type="button"
                  className="btn btn-sm btn-ghost-purple waves-effect waves-light d-flex justify-content-center align-items-center"
                >
                  <img src={comment_icon} width={14} height={14} alt="comment" />
                </button>
              }
              position="top center"
              arrow={false}
            >
              <div
                style={{
                  padding: '16px',
                  background: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                  minWidth: '200px',
                  maxWidth: '300px',
                  color: '#333',
                  fontSize: '13px',
                  fontFamily: 'sans-serif',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontWeight: 600,
                      color: '#5c5c8a',
                      marginBottom: '4px',
                    }}
                  >
                    <span>{t('MCTDetail.TrapHistoryCard.modal.creationComment')}</span>
                  </div>
                  <div
                    style={{
                      background: '#f8f9fa',
                      padding: '8px 10px',
                      borderRadius: '6px',
                      color: vulnerability.comment ? '#495057' : '#adb5bd',
                      fontStyle: vulnerability.comment ? 'normal' : 'italic',
                      wordBreak: 'break-word',
                    }}
                  >
                    {vulnerability.comment || t('MCTDetail.TrapHistoryCard.modal.noCommentProvided')}
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontWeight: 600,
                      color: '#2e7d32',
                      marginBottom: '4px',
                    }}
                  >
                    <span>{t('MCTDetail.TrapHistoryCard.modal.postInspectionComment')}</span>
                  </div>
                  <div
                    style={{
                      background: '#f1f8e9',
                      padding: '8px 10px',
                      borderRadius: '6px',
                      color: vulnerability.fix_comment ? '#2e7d32' : '#adb5bd',
                      fontStyle: vulnerability.fix_comment ? 'normal' : 'italic',
                      wordBreak: 'break-word',
                    }}
                  >
                    {vulnerability.fix_comment || t('MCTDetail.TrapHistoryCard.modal.noInspectionNotesYet')}
                  </div>
                </div>
              </div>
            </ReactPopup>
          </div>
        )}
        {eyes && vulnerability && (
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => onViewCodeModalOpen(vulnerability)}
          >
            <i className="ri-eye-fill icon icon__eyes" />
          </button>
        )}
        {trap && (!isVul || canDeleteVul) && (
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() =>
              isVul ? onCompleteVulOpen(Number(trap.pk)) : openDeleteTrapModal(trap.pk, trap.serialNumber, true)
            }
          >
            <i className="ri-delete-bin-6-fill icon icon__delete" />
          </button>
        )}
        {qrCodeOptions?.qr_code && (
          <button
            type="button"
            className="btn btn-sm btn-ghost-primary btn-icon"
            onClick={() => onQRCodeModalOpen(qrCodeOptions?.qr_code, qrCodeOptions?.msg)}
          >
            <i className="ri-qr-code-fill icon icon__qr-code" />
          </button>
        )}
      </div>
    </>
  );
};

export default ActionCell;
